import * as tslib_1 from "tslib";
/*
 * @Descripttion:
 * @version: v1.0
 * @Author: baidongsheng
 * @Date: 2021-11-12 11:53:15
 * @LastEditors: baidongsheng
 * @LastEditTime: 2021-12-30 20:03:48
 */
import "babel-polyfill";
import "./config/axios";
import env from "@/config/env";
import * as platform from "@cloudpivot/platform";
import { formApi } from "@cloudpivot/api";
import { startup } from "./startup";
import initFormComponent from "@cloudpivot/form/registerComponent";
import common from "@cloudpivot/common/mobile";
import Vues from "vue";
import infiniteScroll from "vue-infinite-scroll";
//引入svg
import './assets/icons/iconfont.js';
Vues.use(infiniteScroll);
// localStorage.setItem('token', 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOlsiYXBpIl0sImNvcnBJZCI6bnVsbCwidXNlcl9pZCI6IjJjOTI4ZmYxN2QzODJiNWQwMTdkNDU4NWE3MTYwMDg0IiwidXNlcl9uYW1lIjoibGVlIiwic2NvcGUiOlsicmVhZCJdLCJtb2JpbGUiOmZhbHNlLCJpc0FkbWluIjp0cnVlLCJleHAiOjE2NDcyNDk0OTYsImlzQXBwQWRtaW4iOmZhbHNlLCJhdXRob3JpdGllcyI6WyJVU0VSIiwiQVVUSF9TWVNURU1fTUFOQUdFIl0sImp0aSI6IjgyZThiMWQ2LWNjNjctNDJlYy1hOTMxLTE5MDQ5MTQ5ZTMyNCIsImNsaWVudF9pZCI6ImFwaSJ9.qp8WVAv588W-3PaCQfSMd-2MvU-NWna_o-VuQbP8mVc074mFPS68dSjp5EuaC6vyV7rDHEZr1yfIeM46MpCsh_zOuXQeD5CvC1kg5LkpM9WMZWlfD5nvapIo7N_n1O64dm7_ZUXkvQpg36DyL_dkAu8kGHBQZUB2dn6Nh2Cdpgc-4Fabf3YsABdQTeA0AvdoyqHSN28ETAqIBro6Be-ba1emxMf9fzAvcw5lkbjq_ctZzfm9zOiiQ5kSos6bcYsbCuzEOtJKPmT31npahVSq0mDIIMaPg6fAsj-0NRmtN_RC76gr9qZF8zWF_U0ai7Ro6bMbApnEeBC-DIigRquAVQ');
initFormComponent();
platform.start(env.client_id, env.scope).then((result) => {
    if (!result)
        return;
    const { query } = result;
    if (query.messageId && common.utils.Common.isPC) {
        openMessage(query.messageId);
    }
    else if (query.messageId && !common.utils.Common.isPC) {
        window.location.href = `${env.portalHost}/mobile/?messageId=${query.messageId}`;
    }
    else {
        startup(query);
        // import(/* webpackChunkName: "startup" */'./startup').then( obj => {
        //   obj.startup(query);
        // });
    }
});
Vues.prototype.getPopupContainer = (triggerNode) => {
    // console.log(triggerNode,'triggerNodetriggerNode',triggerNode.parentNode)
    return triggerNode.parentNode.parentNode;
};
/**
 * 根据消息打开页面
 * @param messageId
 */
function openMessage(messageId) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const $app = document.getElementById("app");
        if (!$app) {
            throw new Error(`can't find #app`);
        }
        const params = {
            messageId
        };
        const token = localStorage.getItem("token");
        if (token) {
            const res = yield formApi.getMessageFormUrl(params);
            if (res.errcode === 0 && res.data) {
                // 跳转到消息地址或者第三方浏览器直接打开地址
                const { bizObjectId, workItemId, workflowInstanceId, schemaCode, sheetCode, url } = res.data;
                // alert(`结果详情：bizobjectid:${bizObjectId},workitemid:${workItemId},workflowinstanceid:${workflowInstanceId}`);
                let theUrl = "";
                if (url) {
                    if (url.indexOf("?") > -1) {
                        theUrl = `${url}&T=${token}`;
                    }
                    else {
                        theUrl = `${url}?T=${token}`;
                    }
                }
                else {
                    theUrl = `${env.portalHost}/form/detail?`;
                    if (workflowInstanceId) {
                        theUrl += `workflowInstanceId=${workflowInstanceId}&workitemId=${workItemId ||
                            ""}&T=${token}`;
                    }
                    else {
                        theUrl += `objectId=${bizObjectId}&schemaCode=${schemaCode}&sheetCode=${sheetCode}&T=${token}`;
                    }
                }
                $app.innerText = "";
                $app.style.textAlign = "center";
                $app.style.paddingTop = "20px";
                $app.style.color = "#666";
                $app.style.fontSize = "18px";
                const $a = document.createElement("a");
                $a.style.textDecoration = "underline";
                $a.href = theUrl;
                $a.target = "_blank";
                $a.innerText = "浏览器打开应用";
                $app.appendChild($a);
                // window.location.href = theUrl;
                platform.service.openLink(theUrl);
            }
        }
        else {
            localStorage.setItem("isShowEmailResquest", `${env.portalHost}?messageId=${messageId}`);
            const theUrl = `${env.portalHost}/login`;
            window.location.href = theUrl;
        }
    });
}
